export function TypingIndicator() {
  return (
    <div
      role="status"
      aria-label="Assistant is typing"
      aria-live="polite"
      className="flex items-center gap-1 px-3 py-2"
    >
      <Dot delay="0s" />
      <Dot delay="0.2s" />
      <Dot delay="0.4s" />
      <span className="sr-only">Typing</span>
    </div>
  );
}

function Dot({ delay }: { delay: string }) {
  return (
    <span
      className="block h-1.5 w-1.5 rounded-full bg-[var(--text-muted)] animate-pulse motion-reduce:animate-none"
      style={{ animationDelay: delay, animationDuration: "1.2s" }}
    />
  );
}
